export default {
  types: [
    { cat: 'HowMany', min: 3, max: 5 },
    { cat: 'HowManyMixed', min: 3, max: 5 },
    { cat: 'HowManyBaseTen', min: 1, max: 9 },
    { cat: 'HowManyIfAdded', min: 1, max: 9 },
    { cat: 'HowManyIfSubtracted', min: 1, max: 9 },
    { cat: 'Addition', min: 0, max: 5, getsHarder: true, difficultyMod: 5, maxCap: 100 },
    { cat: 'Subtraction', min: 0, max: 5, getsHarder: true, difficultyMod: 5, maxCap: 100 },
    { cat: 'Order', howmany: 5 },
    { cat: 'OrderNextNumber', min: 5, max: 96, howmany: 5 },
    { cat: 'AdditionForX', min: 1, max: 5, getsHarder: true, difficultyMod: 5, maxCap: 100 },
    { cat: 'SubtractionForX', min: 1, max: 5, getsHarder: true, difficultyMod: 5, maxCap: 100 }
  ],

  symbols: [
    { char: '^', icon: 'beaker' },
    { char: '|', icon: 'lightbulb' },
    { char: '~', icon: 'wrench' },
    { char: '[', icon: 'thermometer' },
    { char: ']', icon: 'gear' }
  ]

};